import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PieVentasMensualesPorEmpresa from '../PieVentasMensualesPorEmpresa/PieVentasMensualesPorEmpresa';
import TablaMultiempresa from '../TablaMultiempresa/TablaMultiempresa';
import { fechaInicioPeriodoMesActualFunc, fechaFinPeriodoMesActualFunc } from '../../../../shared/fechas';
import { storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';
import * as actions from '../../../../store/actions/index';

const MultiChartVentasMensualesPorEmpresa = (props) => {
    const [viewAsPie, setViewAsPie] = useState(true);

    useEffect(() => {
        if (!props.estaCargado && !props.estaOculto && props.ejecucionDePagina) 
          props.onLoadChart();
        
    }, [props.ejecucionDePagina]);
    
    const handleChangeView = () => {
        setViewAsPie(!viewAsPie)
    }

    return(
        viewAsPie 
        ? 
            <PieVentasMensualesPorEmpresa 
                ejecucionDePagina={props.ejecucionDePagina}
                onPorcionClick={props.onPorcionClick}
                onChangeViewClick={handleChangeView}
                title={`Ventas mensuales por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalVentas)}`}
                height={300}
                width={'100%'}
            />
        : 
            <TablaMultiempresa 
                empresas={props.ventas}
                onChangeViewClick={handleChangeView}
                title={`Ventas mensuales por empresa ${fechaInicioPeriodoMesActualFunc()} al ${fechaFinPeriodoMesActualFunc()}`}
                subtitle={`Total: ${storageMonedaSigno()} ${formatNumber(props.totalVentas)}`}
                height={245}
                width={'100%'}
            />
    )
}

const mapStateToProps = (state) => {
    return {
    ventas: state.multiempresa.ventasMensualesPorEmpresa.ventas,
    totalVentas: state.multiempresa.ventasMensualesPorEmpresa.totalVentas,
    loading: state.multiempresa.ventasMensualesPorEmpresa.loading,
    estaCargado: state.multiempresa.ventasMensualesPorEmpresa.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.ventasMensualesMultiempresa
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
      onLoadChart: () => dispatch(actions.loadVentasMensualesMultiempresa())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiChartVentasMensualesPorEmpresa);